/**
 * Convert a base64 image to grayscale
 * @param {string} base64Image - The original image in base64 format
 * @returns {Promise<string>} - A promise that resolves with the grayscale image in base64 format
 */
export const convertToGrayscale = (base64Image) => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      
      canvas.width = img.width;
      canvas.height = img.height;
      
      // Draw original image
      ctx.drawImage(img, 0, 0);
      
      // Get image data
      const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
      const data = imageData.data;
      
      // Convert to grayscale using luminance formula
      for (let i = 0; i < data.length; i += 4) {
        const r = data[i];
        const g = data[i + 1];
        const b = data[i + 2];
        // Use perceived brightness formula for natural-looking grayscale
        const gray = Math.round(0.299 * r + 0.587 * g + 0.114 * b);
        data[i] = gray;     // Red
        data[i + 1] = gray; // Green
        data[i + 2] = gray; // Blue
      }
      
      // Put the grayscale image data back
      ctx.putImageData(imageData, 0, 0);
      
      // Convert canvas to base64
      const grayScaleBase64 = canvas.toDataURL('image/jpeg', 1.0);
      resolve(grayScaleBase64);
    };
    
    img.onerror = (error) => {
      console.error('Error loading image:', error);
      reject(error);
    };
    
    // Ensure base64 string has correct format
    if (!base64Image.startsWith('data:image')) {
      img.src = 'data:image/jpeg;base64,' + base64Image;
    } else {
      img.src = base64Image;
    }
  });
};
